<div class="d-flex w-100 justify-content-between">
  <div class="d-flex w-100 justify-content-between mr10px">
    <div class="left-wrapper" [class.opacity03]="!type.displayed">
      <img class="event-icon" [src]="diaryUtils.getIcon(type)" alt=""/>
      <span class="event-name">{{type.label}}</span>
    </div>

    <div *ngIf="type.displayed" class="right-wrapper">
      <div *ngIf="!loading" class="enabled-tracker-text">{{activeTrackersCount}}</div>
    </div>
  </div>


  <div class="action-wrapper">
    <div #dropdown="bs-dropdown"
         (click)="$event.stopPropagation()"
         container="body"
         class="dropdown mt15px"
         dropdown>
      <i class="icon-btn more-action-button" dropdownToggle height="24" i-bs name="three-dots" width="24"></i>
      <div class="dropdown-backdrop fade" (click)="dropdown.hide()"></div>
      <ul #bAct
          *dropdownMenu
          class="dropdown-menu dropdown-menu-right"
          [class.dropstart]="!offsetDropdown(bAct, 120)"
          [class.dropend]="offsetDropdown(bAct, 120)"
          role="menu">
        <li role="menuitem">
        <span class="dropdown-item" (click)="dropdown.hide(); onEdit.emit(type)">
          Éditer
        </span>
        </li>
        <li role="menuitem">
        <span class="dropdown-item" (click)="dropdown.hide(); onMask.emit(type)">
          {{ type.displayed ? 'Masquer' : 'Afficher' }}
        </span>
        </li>
        <li class="divider dropdown-divider"></li>
        <li role="menuitem">
        <span class="dropdown-item action" (click)="dropdown.hide()">
          Annuler
        </span>
        </li>
      </ul>
    </div>
  </div>
</div>


